import { Leaf, Users, Star, Clock } from "lucide-react"
import { FancyBrand } from "@/components/fancy-brand"
import { useGoogleReviews } from "@/hooks/use-google-reviews"

export function About() {
  const reviews = useGoogleReviews()

  const ratingTitle = reviews
    ? `Ocena ${reviews.rating.toFixed(1)}/5 w Google`
    : "Najwyższe oceny klientów"
  const ratingDescription = reviews?.userRatingCount
    ? `Klienci cenią nas za jakość produktów, świetne ceny i przyjazną atmosferę – ${reviews.userRatingCount} opinii w Google.`
    : "Klienci cenią nas za jakość produktów, świetne ceny i przyjazną atmosferę."

  const features = [
    {
      icon: Leaf,
      title: "Najlepsze Produkty",
      description:
        "Szeroki wybór liquidów, soli nikotynowych, longfilli i akcesoriów do e-papierosów od najlepszych producentów.",
    },
    {
      icon: Users,
      title: "Profesjonalna Obsługa",
      description:
        "Nasz zespół to doświadczeni pasjonaci, którzy pomogą Ci dobrać idealny sprzęt i smak.",
    },
    {
      icon: Star,
      title: ratingTitle,
      description: ratingDescription,
    },
    {
      icon: Clock,
      title: "Wygodne Godziny",
      description:
        "Otwarci od poniedziałku do piątku 8:00-20:00, w soboty 12:00-20:00, niedziela: zamknięte.",
    },
  ]

  return (
    <section id="o-nas" className="relative py-24">
      {/* Section decorative divider */}
      <div className="absolute top-0 right-0 left-0 h-px bg-gradient-to-r from-transparent via-zielarz-green/30 to-transparent" />

      <div className="mx-auto max-w-7xl px-6">
        {/* Section header */}
        <div className="mb-16 text-center">
          <p className="mb-3 text-sm font-semibold tracking-widest text-zielarz-green uppercase">
            O nas
          </p>
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight sm:text-4xl">
            Dlaczego <FancyBrand size="lg" />?
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Jesteśmy lokalnym sklepem vape w Częstochowie z pasją do jakości.
            Oferujemy najlepsze produkty w przystępnych cenach.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature) => {
            const Icon = feature.icon
            return (
              <div
                key={feature.title}
                className="group relative overflow-hidden rounded-2xl border border-border/50 bg-card/50 p-6 backdrop-blur-sm transition-all duration-300 hover:border-zielarz-green/30 hover:shadow-lg hover:shadow-zielarz-green/5"
              >
                {/* Hover glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-zielarz-green/0 to-zielarz-green/0 transition-all duration-300 group-hover:from-zielarz-green/5 group-hover:to-transparent" />

                <div className="relative">
                  <div className="mb-4 inline-flex rounded-xl border border-zielarz-green/20 bg-zielarz-green/10 p-3 transition-colors group-hover:bg-zielarz-green/20">
                    <Icon className="size-6 text-zielarz-green" />
                  </div>
                  <h3 className="mb-2 text-lg font-bold">{feature.title}</h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {feature.description}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
